export async function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

// Note that when adding a new key to this object
// you need to add it to the PageTitles type and it will get automatically tested
export const RoutePaths = {
    Home: '/',
    CreateSalary: '/create',
    Overview: '/overview',
    Taxcard: '/taxcard',
    Onboarding: '/onboarding',
    EmployeeOverview: '/employees',
    NotFound: '/*',
} as const;

export const PageTitles: { [key in keyof typeof RoutePaths]: string } = {
    Home: 'Home',
    CreateSalary: 'Ny lønnsutbetaling',
    Overview: 'Lønnsoversikt',
    Taxcard: 'Skattekort',
    Onboarding: 'Onboarding',
    EmployeeOverview: 'Ansattoversikt',
    NotFound: 'Not Found',
};

export const removeUndefinedProperties = <T>(obj: Record<string, T | undefined>): Record<string, T> => {
    Object.keys(obj).forEach((key) => {
        if (obj[key] === undefined) {
            delete obj[key];
        }
    });
    return obj as Record<string, T>;
};

export const createOrdinalFromArray = <T>(array: T[]): Record<number, T> => {
    return array.reduce(
        (acc, value, index) => {
            acc[index] = value as T;
            return acc;
        },
        {} as Record<number, T>,
    );
};
